import React, { useState } from "react";
import { Form, Stack, Input, Button } from "basis";

import CountryDropdown from "./CountryDropdown";
import GatewayNameDropdown from "./GatewayNameDropdown";
import requestPaymentAppTempToken from "./utils/requestPaymentAppTempToken";
import { COUNTRY, GATEWAY_NAME } from "../../core/constants";

const validateShopURL = (val, { isEmpty }) => {
  if (isEmpty(val)) {
    return "Required";
  }

  const URL_REGEX = /[(a-zA-Z0-9_-]{2,50}\.(myshopify\.com)/gm;

  if (!Boolean(URL_REGEX.test(val))) {
    return "Please enter a valid url";
  }

  return null;
};

const InstallPaymentMethod = ({ gatewayName, initialValues }) => {
  const [formLoading, setFormLoading] = useState(false);

  const FORM_INITIAL_VALUES = {
    shop: "",
    country:
      gatewayName === GATEWAY_NAME.GENOA_PAY ||
      gatewayName === GATEWAY_NAME.GEM_INTEREST_FREE
        ? COUNTRY.NZ
        : COUNTRY.AU,
    gatewayName: gatewayName || "",
  };

  const handleSubmit = (formData) => {
    const { errors, values } = formData;

    if (Object.keys(errors).length > 0) {
      return;
    }

    const shopName = values.shop.endsWith("/")
      ? values.shop.slice(0, -1)
      : values.shop;

    let updatedValues = {
      ...values,
      shop: shopName.replace(/^https?\:\/\//i, ""),
    };

    setFormLoading(true);

    return requestPaymentAppTempToken(updatedValues);
  };

  return (
    <Form
      initialValues={initialValues || FORM_INITIAL_VALUES}
      method="post"
      onSubmit={handleSubmit}>
      {(formData) => (
        <Stack gap="4">
          {gatewayName === null && (
            <Stack gap="4">
              <CountryDropdown name="country" />

              <GatewayNameDropdown
                country={formData?.state?.values.country}
                name="gatewayName"
                gatewayName={gatewayName}
              />
            </Stack>
          )}
          <Input
            name="shop"
            color="white"
            label="Your Shop URL"
            placeholder="shop.myshopify.com"
            pasteAllowed={true}
            min={4}
            max={20}
            validate={validateShopURL}
            testId="shop"
          />

          <Button loading={formLoading} type="submit">
            Authenticate with Shopify
          </Button>
        </Stack>
      )}
    </Form>
  );
};

export default InstallPaymentMethod;
